import { Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SicotService } from '../sicot.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nuovo-utente-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './nuovo-utente-dialog.component.html',
  styleUrl: './nuovo-utente-dialog.component.css',
})
export class NuovoUtenteDialogComponent {
  private readonly fb = inject(FormBuilder);
  private readonly sicot = inject(SicotService);
  private readonly dialogRef = inject(MatDialogRef<NuovoUtenteDialogComponent>);

  form: FormGroup;
  submitting = false;
  errorMessage: string | null = null;

  constructor() {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      nome: [''],
      cognome: [''],
      email: [''],
      password: ['', [Validators.required]],
    });
  }

  submit(): void {
    if (this.form.invalid || this.submitting) return;
    this.errorMessage = null;
    this.submitting = true;
    const value = this.form.getRawValue();
    const email = typeof value.email === 'string' ? value.email.trim() : '';
    this.sicot.postUserCotAdmin({
      username: value.username,
      nome: value.nome || undefined,
      cognome: value.cognome || undefined,
      email: email || undefined,
      password: value.password,
    }).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.submitting = false;
        this.errorMessage = err?.error?.message ?? err?.message ?? 'Errore durante la creazione dell\'utente';
      },
    });
  }
}
